import React from 'react';


const NotFound=()=>{
	return(
		<div>contact us</div>)
}

export default NotFound;